import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { postNewsletter } from "@/lib/api";

export default function Newsletter({ variant = "dark" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await postNewsletter({ email });
      toast.success(res.message || "You're subscribed!");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex items-stretch w-full max-w-md border border-white/20 focus-within:border-wutn transition-colors">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        data-testid="newsletter-email-input"
        className="flex-1 bg-transparent px-4 py-3.5 text-sm text-white placeholder:text-zinc-500 outline-none"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="bg-wutn hover:bg-wutn-dark disabled:opacity-60 text-white px-5 flex items-center gap-2 font-cond uppercase tracking-wider text-sm transition-colors"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        <span className="hidden sm:inline">Join</span>
      </button>
    </form>
  );
}
